import { gsap } from 'gsap';
import { isTabletDown } from './isMobile';
if (isTabletDown()) {
    let openMenuBtn = document.querySelector('.menu-toggle');
    let mobileMenu = document.querySelector('.mobile-menu');
    let mobileMenuNavLinks = document.querySelectorAll('.mobile-menu .sub-menu-link');
    let back = document.querySelector('.mobile-menu .back');
    let searchBtn = document.querySelector('#search-container');
    let donateButtonPlacement = document.querySelector('#donate-button');
    let header = document.querySelector('.header');
    let isSubmenuOpen = false;
    var menuOpen = false;
    let timeLine;
    let timeLineSubMenu;
    let timeLineBack;
    
    openMenuBtn.addEventListener('click', () => {
        if (!menuOpen) {
            mobileMenu.style.height = (document.body.clientHeight - header.clientHeight) + 'px';
            openMenuBtn.classList.add('active');
            mobileMenu.classList.add('open');
            document.body.classList.add('open-menu');
            searchBtn.classList.add('show');
            donateButtonPlacement.classList.add('hide');
            timeLine = gsap.timeline();
            timeLine.to('.mobile-menu li', 0.5, {
                opacity: 1,
                x: '-=20vw',
                stagger: {
                    each: 0.1,
                    ease: 'power2.out',
                },
            });
            menuOpen = true;
        }
        else {

            if (timeLineBack) {
                timeLineBack.seek(0).pause();
                timeLineBack = null;
            }

            if (timeLineSubMenu) {
                timeLineSubMenu.seek(0).pause();
                timeLineSubMenu = null;
            }

            let activeSubmenu = document.querySelector('.sub-menu.open');
            if (activeSubmenu) {
                let activeSubmenuLinks = activeSubmenu.querySelectorAll('a');
                gsap.set(activeSubmenu, { clearProps: 'all' });
                gsap.set(activeSubmenuLinks, { clearProps: 'all' });
                gsap.set('.back', { clearProps: 'all' });
                activeSubmenu.classList.remove('open');
                isSubmenuOpen = false;                
            }

            gsap.set('.mobile-menu li', { clearProps: 'all' });
            timeLine.seek(0).pause();
            menuOpen = false;
            timeLine = null;
            mobileMenu.classList.remove('open');
            document.body.classList.remove('open-menu');
            searchBtn.classList.remove('show');
            donateButtonPlacement.classList.remove('hide');
            openMenuBtn.classList.remove('active');
            
            
            /*if (isSubmenuOpen) {
                goBack();
                setTimeout(() => {
                    closeMenu();
                }, 3000);
            }
            else {
                closeMenu();
            }*/
        }
    });

    

    back.addEventListener('click', () => {
        // console.log('test');
        goBack();
    });

    function setMenuNavLinksEvent() {
        mobileMenuNavLinks.forEach(el => {
            el.addEventListener('click', (e) => {
                if (document.querySelector('.sub-menu.open')) {
                    e.stopPropagation();
                    return;
                }

                isSubmenuOpen = true;
                timeLineSubMenu = null;
                timeLineSubMenu = gsap.timeline();
                const index = $(e.target).parent().index();
                if (index !== -1) {
                    e.preventDefault();
                    const submenu = document.querySelectorAll('.sub-menu')[index];
                    const submenuLinks = submenu.querySelectorAll('a.sub-menu-link');

                    timeLineSubMenu.set('.back', { visibility: 'visible' })
                        .to('.mobile-menu li', 0.5, {
                            opacity: 0,
                            x: '-=40vw',
                            stagger: {
                                each: 0.1,
                                ease: 'power2.out',
                            },
                    });
                    timeLineSubMenu.to('.socials', 0.5, {
                        opacity: 0,
                        onComplete: () => {
                            submenu.classList.add('open');
                        }
                    });
                    timeLineSubMenu.to(submenuLinks, 1, {
                        opacity: 1,
                        x: '-=20vw',
                        stagger: {
                            each: 0.1,
                            ease: 'power2.out',
                        },
                        delay: 1,
                        onComplete: () => {
                            timeLineSubMenu
                                .to('.sub-menu .contact-block', 0.5, { opacity: 1, x: '-=20vw', })
                                .to('.sub-menu .navbar-socials', 0.5, { opacity: 1, x: '-=20vw', })
                                .to('.back', 0.5, { opacity: 1, x: '-=20vw',});
                        }
                    });
                }
            });
        });
    }
    setMenuNavLinksEvent();
    
    function goBack() {
        let activeSubmenu = document.querySelector('.sub-menu.open');
        let activeSubmenuLinks = activeSubmenu?.querySelectorAll('a.sub-menu-link');

        timeLineBack = gsap.timeline();
        timeLineBack.to('.back', 0.5, { opacity: 0, x: '+=20vw',})
            .to('.sub-menu .contact-block', 0.5, { opacity: 0, x: '+=20vw', })
            .to('.sub-menu .navbar-socials', 0.5, { opacity: 0, x: '+=20vw', })
            .set('.back', { visibility: 'hidden' });
        timeLineBack.to(activeSubmenuLinks, 1, {
            opacity: 0,
            x: '+=20vw',
            stagger: {
                each: 0.1,
                ease: 'power2.out',
            },
            delay: 0.5,
            onComplete: () => {
                timeLineBack.to('.mobile-menu li', 0.5, {
                    opacity: 1,
                    x: '+=40vw',
                    stagger: {
                        each: 0.1,
                        ease: 'power2.out',
                    },
                    onComplete: () => {
                        timeLineBack.to('.socials', 0.5, {
                            opacity: 1,
                            onComplete: () => {
                                activeSubmenu.classList.remove('open');
                            }
                        });
                    }
                });
            }
        });
        isSubmenuOpen = false;
    }
    
    function closeMenu() {
        gsap.to('.mobile-menu li', 0.5, {
            opacity: 0,
            x: '20vw',
            stagger: {
                each: 0.1,
                ease: 'power2.out',
            },
            onComplete: function() {
                mobileMenu.classList.remove('open');
                document.body.classList.remove('open-menu');
                searchBtn.classList.remove('show');
                donateButtonPlacement.classList.remove('hide');
            }
        });
        openMenuBtn.classList.remove('active');
        menuOpen = false;
    }
}
